import React from 'react';
import { Navigate } from 'react-router-dom';
import useRoutes from '../../routes/useRoutes';

const RedirectToMenu = () => {
  const routes = useRoutes();
  return <Navigate to={routes.menuRoute()} replace />;
};

export default RedirectToMenu;
